import script from "./AddAttach.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAttach.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__